<template>
  <div id="app">
    <main-header></main-header>
    <router-view/>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainHeader from './pages/header'
import MainFooter from './pages/footer'
export default {
  components: {
    MainHeader,
    MainFooter
  },
  name: 'App'
}
</script>

<style>
html,body{-webkit-text-size-adjust:none;}
/* CSS-Reset */
.w1200{width: 1200px;overflow: hidden;margin: 0 auto;min-width: 1200px;}
body{min-width: 1200px;font-family: Arial,'微软雅黑','Microsoft YaHei',PingFangSC-Regular;}
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,form,fieldset,input,textarea,blockquote,img,form{padding:0; margin:0;}
table,td,tr,th{font-size:12px}
li{list-style-type:none;list-style:none;}
img{vertical-align:top;border:0;}
ol,ul {list-style:none;}
h1,h2,h3,h4,h5,h6 {font-weight:normal;font-style:normal;font-size:12px}
/* tystyle */
body{font-size:14px;background-color: #fff;line-height:1.5;color:#333;}
a{text-decoration:none} /* 针对IE */
a:hover{text-decoration:none;}
a,button,input,div,li{-webkit-tap-highlight-color:rgba(0,0,0,0);outline: none;}
.amn1{transition:all ease-out .1s 0s;-webkit-transition:all ease-out .1s 0s;-moz-transition:all ease-out .1s 0s;-o-transition:all ease-out .1s 0s;}
.amn2{transition:all ease-out .2s 0s;-webkit-transition:all ease-out .2s 0s;-moz-transition:all ease-out .2s 0s;-o-transition:all ease-out .2s 0s;}
.amn3{transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;}
.swiper-pagination{
  bottom: 30px!important;
}
.swiper-pagination .swiper-pagination-bullet{
  width: 50px;
  height: 6px;
  background-color: #fff;
  border-radius: 0;
  border-radius: 1px;
  opacity: 0.6;
}
.swiper-pagination .swiper-pagination-bullet-active{
  opacity: 1;
}
.box4 .swiper-pagination{
  bottom: 50px!important;
}
.box4 .swiper-pagination-bullet{
  background:none;
  opacity:1;
  margin:0 6px !important;
  width:9px;
  height:9px;
  position:relative;
  outline:none;
  vertical-align:middle;}
.box4 .swiper-pagination-bullet span{
  width:3px;
  height:3px;
  background:#CCC;
  display:block;
  border-radius:50%;
  margin-top:3px;
  margin-left:3px;
}
.box4 .swiper-pagination-bullet i{
  background:#000;
  height:1px;
  width:20px;
  position:absolute;
  top:4px;
  transform:scaleX(0);
  transform-origin:left;
  z-index:3;
  transition-timing-function:linear;
}
.box4 .swiper-pagination-bullet-active span,.box4 .swiper-pagination-bullet:hover span{
  width:9px;
  height:9px;
  margin-top:0;
  margin-left:0;
  background:#000;
  position:relative;
  z-index:1;
}
.box4 .swiper-pagination-bullet-active i{
  animation:middle 6s;
}
.box4 .swiper-pagination-bullet:first-child.swiper-pagination-bullet-active i{
  animation:first 6s;
}
.box4 .swiper-pagination-bullet:last-child.swiper-pagination-bullet-active i{
  animation:last 6
}
@keyframes first{
  0% {transform:scaleX(0.5);left:0px;}/*091*/
  100% {transform:scaleX(1);left:2px;} /*0915*/
}
@keyframes last{
  0% {transform:scaleX(0.7);left:-10px;}/*1090*/
  20% {transform:scaleX(0.3);left:2px;} /*090*/
  100% {transform:scaleX(0.3);left:0px;} /*090*/
}
@keyframes middle{
  0% {transform:scaleX(0.7);left:-10px;}/*1091*/
  20% {transform:scaleX(0.45);left:2px;}/*092*/
  100% {transform:scaleX(1);left:2px;} /*0913*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue